import React, { useState } from "react";
import "./scss/MemberInvitation.scss";
import { config } from "../../config";

const MemberInvitation = ({ members, boardId, onComplete, onSkip }) => {
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [isInviting, setIsInviting] = useState(false);
  const [inviteResults, setInviteResults] = useState(null);

  const handleMemberToggle = (email) => {
    setSelectedMembers(prev => 
      prev.includes(email) 
        ? prev.filter(e => e !== email)
        : [...prev, email]
    );
  };


  const handleSelectAll = () => {
    if (selectedMembers.length === members.length) {
      setSelectedMembers([]);
    } else {
      setSelectedMembers(members.map(m => m.email));
    }
  };

  const handleSendInvitations = async () => {
    if (selectedMembers.length === 0) {
      alert("Please select at least one member to invite");
      return;
    }

    setIsInviting(true);
    try {
      const response = await fetch(`${config.API_URI}/v1/fluent/invite-members`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          boardId: boardId,
          memberEmails: selectedMembers,
          message: `You've been invited to join this board after import.`
        })
      });

      const result = await response.json();
      
      if (response.ok) {
        setInviteResults(result.results);
      } else {
        throw new Error(result.message || 'Failed to send invitations');
      }
    } catch (error) {
      console.error('Error sending invitations:', error);
      alert(`Failed to send invitations: ${error.message}`);
    } finally {
      setIsInviting(false);
    }
  };

  if (inviteResults) {
    return (
      <div className="member-invitation">
        <div className="invitation-results">
          <h2>Invitation Results</h2>
          <div className="results-list">
            {inviteResults.map((result, index) => (
              <div key={index} className={`result-item ${result.status}`}>
                <span className="email">{result.email}</span>
                <span className="status">{result.message}</span>
              </div>
            ))}
          </div>
          <div className="actions">
            <button onClick={onComplete} className="btn-primary">
              Continue to Dashboard
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="member-invitation">
      <div className="invitation-container">
        <h2>Invite Board Members</h2>
        <p className="description">
          Your board has been imported successfully! Would you like to invite the board members to your workspace?
        </p>

        <div className="members-section">
          <div className="section-header">
            <h3>Board Members ({members.length})</h3>
            <button 
              onClick={handleSelectAll}
              className="select-all-btn"
            >
              {selectedMembers.length === members.length ? 'Deselect All' : 'Select All'}
            </button>
          </div>

          <div className="members-list">
            {members.map((member, index) => (
              <div key={index} className="member-item">
                <label className="member-checkbox">
                  <input
                    type="checkbox"
                    checked={selectedMembers.includes(member.email)}
                    onChange={() => handleMemberToggle(member.email)}
                  />
                  <span className="checkmark"></span>
                </label>
                
                <div className="member-info">
                  {member.avatar && (
                    <img 
                      src={member.avatar} 
                      alt={member.name}
                      className="member-avatar"
                      loading="lazy"
                    />
                  )}
                  <div className="member-details">
                    <span className="member-name">{member.name}</span>
                    <span className="member-email">{member.email}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="invitation-actions">
          <button 
            onClick={onSkip}
            className="btn-secondary"
            disabled={isInviting}
          >
            Skip Invitations
          </button>
          <button 
            onClick={handleSendInvitations}
            className="btn-primary"
            disabled={isInviting || selectedMembers.length === 0}
          >
            {isInviting ? 'Sending...' : `Send Invitations (${selectedMembers.length})`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MemberInvitation;
